export default __webpack_public_path__ + "static/media/P14.a6387598.png";